import React, { useState } from 'react'
import ArchiveIcon from '../icons/archive'
import EditIcon from './icons/edit'
import SendNoteIcon from './icons/send-note'
import RegenerateIcon from './icons/regenerate'
import Divider from '../divider'
import { PortalTooltip as Tooltip } from '../tooltip'
import styled from 'styled-components'
import { NoteModalsWrapper } from '../send-note-modal'
import ArchiveModal from '../archive-modal'
import DocumentFormModal from '../document-form-modal'
import useRegenerate1919 from './useRegenerate1919'

const ContainerElement = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
`

const IconWrapperElement = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;

  &:hover {
    opacity: 0.6;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.2;
  }
`

const isDocumentType4506 = (documentType) =>
  documentType.startsWith('Document::T4506')

function Options({ loanId, document, entity, isArchived }) {
  const { rid: documentId, comment, deletable, type, files } = document

  const [showEditModal, setShowEditModal] = useState(false)
  const [showArchiveModal, setShowArchiveModal] = useState(false)
  const [showSendNoteModal, setShowSendNoteModal] = useState(false)

  const allowArchive = isArchived
    ? false
    : isDocumentType4506(type)
    ? files.length > 0
    : deletable

  const {
    showRegenerateOption,
    handleRegenerate,
    preventRegeneration,
    regenerating,
  } = useRegenerate1919({
    loanId,
    document,
  })

  return (
    <>
      <ContainerElement>
        <Tooltip text="Send note">
          <IconWrapperElement
            id={`send-note-document-bucket-button-${documentId}`}
            onClick={() => setShowSendNoteModal(true)}
          >
            <SendNoteIcon />
          </IconWrapperElement>
        </Tooltip>
        <Divider vertical />
        {allowArchive && (
          <>
            <Tooltip text="Archive document bucket">
              <IconWrapperElement
                id={`archive-document-bucket-button-${documentId}`}
                onClick={() => setShowArchiveModal(true)}
              >
                <ArchiveIcon width={26} />
              </IconWrapperElement>
            </Tooltip>
            <Divider vertical />
          </>
        )}
        <Tooltip text="Edit document bucket">
          <IconWrapperElement
            id={`edit-document-bucket-button-${documentId}`}
            onClick={() => setShowEditModal(true)}
          >
            <EditIcon />
          </IconWrapperElement>
        </Tooltip>
        {showRegenerateOption && (
          <>
            <Divider vertical />
            <Tooltip
              text={
                preventRegeneration
                  ? 'You must un-approve the document to regenerate'
                  : regenerating
                  ? 'Regenerating...'
                  : 'Regenerate'
              }
            >
              <IconWrapperElement
                id={`regenerate-document-bucket-button-${documentId}`}
                disabled={preventRegeneration || regenerating}
                onClick={handleRegenerate}
              >
                <RegenerateIcon />
              </IconWrapperElement>
            </Tooltip>
          </>
        )}
      </ContainerElement>
      {showEditModal && (
        <DocumentFormModal
          loanId={loanId}
          editingAttrs={{ document, owner: entity }}
          onClose={() => setShowEditModal(false)}
        />
      )}
      {showArchiveModal && (
        <ArchiveModal
          documentId={documentId}
          onClose={() => setShowArchiveModal(false)}
        />
      )}
      {showSendNoteModal && (
        <NoteModalsWrapper
          documentId={documentId}
          note={comment}
          onClose={() => setShowSendNoteModal(false)}
        />
      )}
    </>
  )
}

export default Options
